export const routes = (prefix = `billing`, pref = `consultant-dashboard`) => [
    {
        path: `/${prefix}/${pref}/payment/reverse`,
        name: `${prefix}.${pref}.payment.reverse.create`,
        component: () => import('./Form.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.${pref}.payment.reverse.create`,
                PageDescription: "Consultant Payment: Reverse Payments",
            },
        },
    },
];
